import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=71e116fc&scoped=true&"
import script from "./Changelog.vue?vue&type=script&lang=js&"
export * from "./Changelog.vue?vue&type=script&lang=js&"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=71e116fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e116fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
